/**
 * Combined Show Listing + Calendar component for Alpine.js
 *
 * Returns a single x-data object that handles:
 * - Filter proxying (delegates to createFilter)
 * - View toggling (list / calendar)
 * - Calendar month grid built from card data-* attributes
 */
window.createShowListing = function () {
    var filter = createFilter({
        pills: ['when'],
        dropdowns: ['promo', 'tag'],
        cardSelector: '.card-d',
        groupSelector: '.week-group'
    });

    var MONTHS = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    var now = new Date();
    now.setHours(0, 0, 0, 0);
    var todayStr = now.getFullYear() + '-' +
        String(now.getMonth() + 1).padStart(2, '0') + '-' +
        String(now.getDate()).padStart(2, '0');

    return {
        // View state
        view: (new URLSearchParams(window.location.search)).get('view') || 'list',

        // Filter state — proxied from createFilter
        when: filter.when,
        promo: filter.promo,
        tag: filter.tag,
        _filter: filter,

        // Calendar state
        calYear: now.getFullYear(),
        calMonth: now.getMonth(),
        calDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],

        init: function () {
            // Keep filter proxy in sync with Alpine reactivity
            var self = this;
            this.$watch('when', function (val) { self._filter.when = val; });
            this.$watch('promo', function (val) { self._filter.promo = val; });
            this.$watch('tag', function (val) { self._filter.tag = val; });

            // Sync view state to URL so back button preserves it
            this.$watch('view', function (val) {
                var url = new URL(window.location);
                if (val === 'list') {
                    url.searchParams.delete('view');
                } else {
                    url.searchParams.set('view', val);
                }
                history.replaceState(null, '', url);
            });
        },

        // Filter proxies
        togglePill: function (name, value) {
            this._filter.togglePill(name, value);
            this.when = this._filter.when;
        },
        cardVisible: function (el) {
            return this._filter.cardVisible(el);
        },
        visibleCount: function () {
            return this._filter.visibleCount();
        },
        clearFilters: function () {
            // Reset both the Alpine-facing copies (so x-model/pills update) and
            // the underlying filter engine state in the same tick.
            this.when = null;
            this.promo = '';
            this.tag = '';
            this._filter.when = null;
            this._filter.promo = '';
            this._filter.tag = '';
        },

        // Cross-sell cards repeat down the whole listing (the server cycles the
        // enabled adverts, one after every Nth week group). A card renders as
        // long as the week group it follows still has a visible show — so cards
        // thin out naturally as filters hide groups, and vanish at 0 shows.
        xsellVisible: function (el) {
            return this.bannerVisible(el);
        },
        // Any interleaved banner (custom CMS banners included) hides when
        // nothing matches the filters, or when the week group it follows is
        // entirely filtered out — otherwise banners stack up on their own.
        bannerVisible: function (el) {
            if (this.visibleCount() === 0) return false;
            var prev = el.previousElementSibling;
            while (prev && !prev.classList.contains('week-group')) {
                prev = prev.previousElementSibling;
            }
            if (!prev) return true;
            var cards = prev.querySelectorAll('.card-d');
            for (var i = 0; i < cards.length; i++) {
                if (this._filter.cardVisible(cards[i])) return true;
            }
            return false;
        },

        // Calendar nav
        get calLabel() {
            return MONTHS[this.calMonth] + ' ' + this.calYear;
        },
        calPrev: function () {
            if (this.calMonth === 0) { this.calMonth = 11; this.calYear--; }
            else { this.calMonth--; }
        },
        calNext: function () {
            if (this.calMonth === 11) { this.calMonth = 0; this.calYear++; }
            else { this.calMonth++; }
        },

        // Calendar grid — flat array of cells
        get calCells() {
            // Read shows from card DOM elements
            var shows = {};
            var cards = document.querySelectorAll('.card-d');
            for (var i = 0; i < cards.length; i++) {
                var card = cards[i];
                var dateStr = card.dataset.date;
                if (!dateStr) continue;
                if (!shows[dateStr]) shows[dateStr] = [];
                shows[dateStr].push({
                    title: card.dataset.showTitle || '',
                    time: card.dataset.showTime || '',
                    dow: card.dataset.showDow || '',
                    day: card.dataset.showDay || '',
                    link: card.getAttribute('href'),
                    status: card.dataset.bookingStatus || '',
                    image: card.dataset.showImage || '',
                    price: card.dataset.showPrice || '',
                    isFree: card.dataset.showFree === '1',
                    duration: card.dataset.showDuration || '',
                    el: card
                });
            }

            var firstDay = new Date(this.calYear, this.calMonth, 1);
            var lastDate = new Date(this.calYear, this.calMonth + 1, 0).getDate();

            // Monday=0 .. Sunday=6
            var startDow = firstDay.getDay() - 1;
            if (startDow < 0) startDow = 6;

            var cells = [];
            var self = this;

            // Leading padding
            for (var p = 0; p < startDow; p++) {
                cells.push({ key: 'pre-' + p, day: null, shows: [], isToday: false });
            }

            // Day cells
            for (var d = 1; d <= lastDate; d++) {
                var m = String(this.calMonth + 1).padStart(2, '0');
                var dd = String(d).padStart(2, '0');
                var key = this.calYear + '-' + m + '-' + dd;

                var dayShows = (shows[key] || []).filter(function (s) {
                    return self._filter.cardVisible(s.el);
                });

                cells.push({
                    key: key,
                    day: d,
                    shows: dayShows,
                    isToday: key === todayStr,
                    isPast: key < todayStr
                });
            }

            // Trailing padding
            var pad = 0;
            while (cells.length % 7 !== 0) {
                cells.push({ key: 'post-' + (pad++), day: null, shows: [], isToday: false });
            }

            return cells;
        }
    };
};

/* ─── Popover positioning ─── */
(function () {
    document.addEventListener('mouseover', function (e) {
        var wrap = e.target.closest('.cal__show-wrap');
        if (!wrap) return;

        var popover = wrap.querySelector('.cal__popover');
        if (!popover) return;

        var rect = wrap.getBoundingClientRect();
        var pw = 260; // popover width

        // Center horizontally on the pill, clamp to viewport
        var left = rect.left + rect.width / 2 - pw / 2;
        left = Math.max(8, Math.min(left, window.innerWidth - pw - 8));

        // Position above the pill
        var top = rect.top - 8;
        popover.style.left = left + 'px';
        popover.style.bottom = (window.innerHeight - top) + 'px';
        popover.style.top = 'auto';
    });
})();
